import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './reducers';
import appActions from './actions';

const isDevelopment = process.env.NODE_ENV === 'development';

// Redux Configuration
const middleware = [];
const enhancers = [];

// logging Middleware
if (isDevelopment) {
	middleware.push(
		createLogger({
			level: 'info',
			collapsed: true,
		}),
	);
}

// Thunk Middleware
middleware.push(thunk);

// Redux DevTools Configuration
const actionCreators = {
	...appActions,
};

// In development, use the browser's Redux dev tools extension if installed
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
	? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
			// Options: http://extension.remotedev.io/docs/API/Arguments.html
			actionCreators,
	  })
	: compose;

// Apply Middleware & Compose Enhancers
enhancers.push(applyMiddleware(...middleware));
const enhancer = composeEnhancers(...enhancers);

// Create Store
const store = createStore(rootReducer, enhancer);
export default store;
